import type { FeatureRouteModule } from '@skynet/feature-config';

/**
 * Dynamic-import thunks of the auth pages, one chunk each. The pages are
 * deliberately not exported from the package entry: the app imports it eagerly
 * for the URLs, and a page re-export would drag the pages onto the boot path.
 */
export const authPages = {
  signUpLayout: async (): Promise<FeatureRouteModule> => ({
    default: (await import('./SignUp/SignUpLayout')).SignUpLayout,
  }),
  signUp: async (): Promise<FeatureRouteModule> => ({
    default: (await import('./SignUp/SignUpPage')).SignUpPage,
  }),
  signUpConfirmation: async (): Promise<FeatureRouteModule> => ({
    default: (await import('./SignUp/SignUpConfirmation')).SignUpConfirmation,
  }),
  signUp2FA: async (): Promise<FeatureRouteModule> => ({
    default: (await import('./SignUp/Setup2FAForm')).Setup2FAForm,
  }),
  signInLayout: async (): Promise<FeatureRouteModule> => ({
    default: (await import('./Signin/SignLayout')).SignLayout,
  }),
  signIn: async (): Promise<FeatureRouteModule> => ({
    default: (await import('./Signin/SigninForm')).SigninForm,
  }),
  signIn2FA: async (): Promise<FeatureRouteModule> => ({
    default: (await import('./Signin/SigninTwoFAForm')).SigninTwoFAForm,
  }),
  signInResetPassword: async (): Promise<FeatureRouteModule> => ({
    default: (await import('./Signin/ResetPassword/ResetPasswordPage')).ResetPasswordPage,
  }),
  signInRecovery: async (): Promise<FeatureRouteModule> => ({
    default: (await import('./Signin/RecoveryForm')).RecoveryForm,
  }),
};
